<template>
  <CDialog
    v-bind="{ show }"
    no-header
    @close="close"
    custom-class="!max-w-[421px]"
  >
    <div class="p-5">
      <div>
        <p class="text-xl font-semibold mb-2">
          {{ notificationType?.title }}
        </p>
        <p
          class="text-sm font-medium"
          v-html="convertToHtml(notificationType?.message)"
        />
      </div>
      <div class="mt-7 flex-y-center gap-2">
        <CButton
          v-if="
            notificationSingle?.notification?.type === 'robot' &&
            notificationSingle?.notification?.trade
          "
          variant="dark"
          class="w-full"
          @click="viewTrade"
          :text="$t('view_trade')"
        />
        <CButton
          variant="info"
          class="w-full"
          @click="close"
          :text="$t('close')"
        />
      </div>
    </div>
  </CDialog>
</template>

<script setup lang="ts">
import CDialog from "@/components/Common/Dialog/CDialog.vue";
import CButton from "@/components/Common/CButton.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useNotificationStore } from "@/modules/Notification/stores";
import { useRoute } from "vue-router";

interface Props {
  show: boolean;
}
defineProps<Props>();
const emit = defineEmits<{
  (e: "close"): void;
}>();

const router = useRouter();
const route = useRoute();
const { t } = useI18n();

const notificationStore = useNotificationStore();

const notificationSingle = computed(() => notificationStore.notificationSingle);

const notificationType = computed(() => {
  switch (notificationSingle.value?.notification?.notification_template?.type) {
    case "money_request_rejected":
      return {
        title: t("money_request_rejected"),
        message: notificationSingle.value?.notification?.message,
        created_at: notificationSingle.value?.notification?.created_at,
      };
    case "money_request_accepted":
      return {
        title: t("money_request_accepted"),
        message: notificationSingle.value?.notification?.message,
        created_at: notificationSingle.value?.notification?.created_at,
      };
    case "referral_request_rejected":
      return {
        title: t("referral_request_rejected"),
        message: notificationSingle.value?.notification?.message,
        created_at: notificationSingle.value?.notification?.created_at,
      };
    case "referral_request_accepted":
      return {
        title: t("referral_request_accepted"),
        message: notificationSingle.value?.notification?.message,
        created_at: notificationSingle.value?.notification?.created_at,
      };
    case "balance_less_10_usdt":
      return {
        title: t("balance_less_10_usdt"),
        message: notificationSingle.value?.notification?.message,
        created_at: notificationSingle.value?.notification?.created_at,
      };
    case "balance_equal_0_usdt":
      return {
        title: t("balance_equal_0_usdt"),
        message: notificationSingle.value?.notification?.message,
        created_at: notificationSingle.value?.notification?.created_at,
      };
    case "trade_close":
      return {
        title: t("trade_close"),
        message: notificationSingle.value?.notification?.message,
        created_at: notificationSingle.value?.created_at,
      };
    case "trade_open":
      return {
        title: t("trade_open"),
        message: notificationSingle.value?.notification?.message,
        created_at: notificationSingle.value?.created_at,
      };
    case "plan_expired":
      return {
        title: t("plan_expired"),
        message: notificationSingle.value?.notification?.message,
        created_at: notificationSingle.value?.created_at,
      };
    case "plan_expire_after_7_days":
      return {
        title: t("plan_expire_after_7_days"),
        message: notificationSingle.value?.notification?.message,
        created_at: notificationSingle.value?.notification?.created_at,
      };
    case "plan_expire_after_1_days":
      return {
        title: t("plan_expire_after_1_days"),
        message: notificationSingle.value?.notification?.message,
        created_at: notificationSingle.value?.notification?.created_at,
      };
    default:
      return "default";
  }
});

const viewTrade = () => {
  if (notificationSingle.value?.notification?.type === "robot") {
    // Get the current locale from the route path
    const locale = route.path.split("/")[1];

    router.push({
      name: `${locale}-BotsCoinSingle`,
      params: {
        coinId: notificationSingle.value?.notification?.trade?.id,
        botId: notificationSingle.value?.notification?.bot_id,
      },
    });
    close();
  }
};
function convertToHtml(message: string) {
  // Replace newline characters with <br> tags
  const htmlMessage = message?.replace(/(?:\r\n|\r|\n)/g, "<br>");

  return htmlMessage;
}
function close() {
  emit("close");
}
</script>
